<div class="dropArea d-flex align-items-center justify-content-center">

  @if (!fileSelected && !loading) {
    <mat-icon>attach_file</mat-icon>
    <span class="text">Upload file</span>
  }

  @if (currentFile) {
    {{ currentFile.name }}
  }

  @if (loading) {
    <mat-spinner color="accent"></mat-spinner>
  }

</div>

<input type="file" #fileInput (change)="selectFile($event.target.files)">


<button class="help" mat-icon-button matTooltip="You can upload files and the request will be updated with their base64 representation">
  <mat-icon>help</mat-icon>
</button>
